import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import Button from "../../../Common/Buttons/Button";
import PopupManager from "../../../Common/Popups/PopupManager";
import TouchNumbers from "../../../Common/TouchNumbers/TouchNumbers";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

interface Props extends PropsFromRedux {
    callback: (weight: number) => void;
}

interface State {
    value: string;
}

export class RequestWeight extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            value: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
    }

    public handleChange(value: string): void {
        this.setState({
            value: value,
        });
    }

    public handleContinue(): void {
        if(isNaN(parseFloat(this.state.value)) || !this.state.value) {
            PopupManager.error("Please enter valid weight");

            return;
        }

        this.props.dispatch(hideDialog());
        this.props.callback(parseFloat(this.state.value));
    }

    public cancelRequest(): void {
        this.props.dispatch(hideDialog());
    }

    public render(): React.ReactNode {
        return (
            <div className="request-weight">
                <p>Please enter weight:</p>
                <TouchNumbers
                    static
                    hideConfirm
                    value={this.state.value}
                    onChange={this.handleChange}
                    onConfirm={this.handleContinue}
                    autoFocus
                />
                <div className="buttons">
                    <Button
                        type="button"
                        classes={[ "button-cancel" ]}
                        onClick={this.cancelRequest}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        classes={[ "button-add" ]}
                        onClick={this.handleContinue}
                    >
                        Continue
                    </Button>
                </div>
            </div>
        );
    }
}

export default connector(RequestWeight);
